import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { post } from '../../lib/api.ts';
import { Button } from '../../components/ui/Button.tsx';
import { ErrorText } from '../../components/AuthShell.tsx';
import { FormSheet, FormSection, FormField, ftInput } from '../../components/ui/FormTable.tsx';
import { EntityPicker } from '../../components/ui/EntityPicker.tsx';
import { useUserPicker } from '../../lib/pickers.ts';

export function RemediationTaskNewPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const userPicker = useUserPicker();
  const [f, setF] = useState({ title: '', description: '', ownerId: '', dueDate: '' });
  const create = useMutation({ mutationFn: () => post<{ id: string }>('/assessments/tasks', { title: f.title, description: f.description || undefined, ownerId: f.ownerId || undefined, dueDate: f.dueDate || undefined }), onSuccess: (r) => { qc.invalidateQueries({ queryKey: ['remediation-grid'] }); navigate(`/assessments/tasks/${r.id}`); } });
  return (
    <div className="">
      <PageHeader title="개선과제 등록" back={{ to: '/assessments/tasks', label: '목록' }} />
      <FormSheet description="점검과 무관한 개선과제를 수동으로 등록합니다. 완료는 완료 증적을 첨부한 종결 결재로만 처리됩니다." actions={<><Button variant="secondary" onClick={() => navigate('/assessments/tasks')}>취소</Button><Button type="submit" busy={create.isPending}>등록</Button></>} onSubmit={(e) => { e.preventDefault(); create.mutate(); }}>
        <FormSection title="과제">
          <FormField label="제목" required span={2}><input className={ftInput + ' ft-w-full'} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} required /></FormField>
          <FormField label="담당자" hint="비우면 나"><EntityPicker value={f.ownerId} onChange={(v) => setF({ ...f, ownerId: v })} emptyLabel="(나)" {...userPicker} /></FormField>
          <FormField label="기한"><input className={ftInput + ' ft-w-sm'} type="date" value={f.dueDate} onChange={(e) => setF({ ...f, dueDate: e.target.value })} /></FormField>
          <FormField label="내용" span={2}><textarea className={ftInput + ' ft-w-full'} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} /></FormField>
        </FormSection>
        <ErrorText error={create.error} />
      </FormSheet>
    </div>
  );
}
